<template>
  <div>
    <bread-cump :cumps="$route.meta.breadcrumps" :params="$route.params" />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="12">
          <v-card class="card--shadow">
            <list :counselingData="counselingData" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/counseling/List";
import { mapState } from "vuex";
import BreadCump from "@/components/navigation/BreadCump";
export default {
  components: {
    List,
    BreadCump,
  },
  computed: {
    ...mapState("Counseling", ["counselingData"]),
  },
  created() {
    this.$store.dispatch("Counseling/getAll", {
      month: this.$route.params.month,
      year: this.$route.params.year,
      township_id: this.$route.params.township_id,
      // township_id: this.$route.query.township,
    });
  },
};
</script>
